<template>
  <div>
    <div class="input-group" v-once>
      <input ref="input" :value="initialValue" @input="updateValue($event.target.value)" class="form-control" :class="{ 'is-invalid': valid }" />

      <div class="input-group-append">
        <span class="input-group-text" @click="showCalculator = !showCalculator" style="cursor: pointer;">
          <i class="fas fa-calculator"></i>
        </span>
      </div>
    </div>

    <input-number-calculator v-if="showCalculator" @click="onCalculatorClick" @erase="onCalculatorErase" />
  </div>
</template>


<script>
  import InputNumberCalculator from './InputNumberCalculator'

  const pattern = /^\d*([\.,]\d{0,2})?$/

  function createPattern(decimals) {
    let pattern = '^\\d*$'
    if(decimals >= 1) {
      pattern = '^\\d*([\\.,]\\d{0,' + decimals + '})?$'
    }
    return new RegExp(pattern)
  }

  function validateValue(val) {
    return pattern.test(val.trim()) //val.split('').every(c => digits.includes(c) || separators.includes(c))
  }

  function formatValue(val) {
    return val.replace('.', ',')
  }

  function parseFormattedValue(val) {
    return Number(val.replace(',', '.'))
  }

  function setValueKeepCursor(el, val) {
    var start = el.selectionStart, end = el.selectionEnd
    el.value = val
    el.setSelectionRange(start, end)
  }

  export default {
    props: {
      value: {
        required: true
      },
      decimals: {
        type: Number,
        default: 0
      },
      min: {
        type: Number,
        default: 0
      },
      max: {
        type: Number,
        default: 100000000
      }
    },

    data() {
      return {
        initialValue: null,
        oldValue: null,
        valid: false,
        showCalculator: false
      }
    },

    created() {
      this.initialValue = formatValue(''+this.value)
      this.oldValue = this.value
      this.pattern = createPattern(this.decimals)
    },

    methods: {
      onCalculatorClick(char) {
        this.updateValue(this.$refs.input.value + char)
      },

      onCalculatorErase() {
        let val = this.$refs.input.value.substr(0, this.$refs.input.value.length-1)
        console.log('erase to ' + val)
        this.updateValue(val)
      },

      validateNumValue(val) {
        this.valid = val >= this.min && val <= this.max
        return this.valid
      },

      validateValue(val) {
        console.log(this.pattern)
        this.valid = this.pattern.test(val.trim())
        return this.valid
      },

      updateValue: function (value) {
        if(! this.validateValue(value)) {
          console.log('not valid')
          setValueKeepCursor(this.$refs.input, this.oldValue)
          return;
        }


        let formattedValue = formatValue(value)
        let numValue = parseFormattedValue(formattedValue)

        this.validateNumValue(numValue)

        // If the value was not already normalized,
        // manually override it to conform
        if (formattedValue !== this.$refs.input) {
          setValueKeepCursor(this.$refs.input, formattedValue)
        }
        this.oldValue = formattedValue
        // Emit the number value through the input event
        this.$emit('input', numValue)
      }
    },

    components: {
      InputNumberCalculator
    }
  }
</script>


<style scoped>
  .col {
    padding: 3px;
  }
  input {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/InputNumber.vue